export default __webpack_public_path__ + "static/full-logo-61432a30ee0a50fb942072e1ddeba311.png";